/* FlagReview.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines-per-function */
import { LoadingButton } from '@atlaskit/button';
import { IconButton } from '@atlaskit/button/new';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import { AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import CrossCircleIcon from '@atlaskit/icon/core/cross-circle';
import FlagIcon from '@atlaskit/icon/core/flag';
import InformationIcon from '@atlaskit/icon/core/information';
import ShowMoreVerticalIcon from '@atlaskit/icon/core/show-more-vertical';
import { Popup } from '@atlaskit/popup';
import { flagReview } from '@atlassian/mpac-api-client';
import { BodySmall } from '@atlassian/mpac-primitives';
import { log } from '@atlassian/mpac-utils';
import React, { useEffect, useState } from 'react';
import { useAsync } from 'react-async';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _3 = "._12rk1gjq._12rk1gjq>span{color:var(--ds-text-subtle,#44546f)}";
const _2 = "._12rk14q2._12rk14q2>span{color:var(--ds-link,#0c66e4)}";
const _ = "._3zhz1b66._3zhz1b66>span{margin-left:var(--ds-space-050,4px)}";
const FlagButton = forwardRef((_ref, __cmplr) => {
  let {
      as: C = LoadingButton,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_3zhz1b66", __cmplp.isFlagged ? "_12rk14q2" : "_12rk1gjq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  FlagButton.displayName = 'FlagButton';
}
export const FlagReview = _ref2 => {
  let {
    mpacBaseUrl,
    flagEndpoint,
    isPopup
  } = _ref2;
  const [isOpen, setIsOpen] = useState(false);
  const [isReviewFlagged, setIsReviewFlagged] = useState(false);
  const [showFlagBanner, setShowFlagBanner] = useState(null);
  const {
    isPending: isFlagInProgress,
    isFulfilled: isFlagSuccessful,
    isRejected: isFlagRejected,
    error: flagError,
    run: runFlagReview
  } = useAsync({
    deferFn: flagReview
  });
  useEffect(() => {
    if (isFlagRejected) {
      setShowFlagBanner('failure');
      log.error('ReviewsTab', 'failed to flag a review', {
        error: flagError
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFlagRejected]);
  useEffect(() => {
    if (isFlagSuccessful) {
      setIsReviewFlagged(prev => !prev);
      setShowFlagBanner('success');
    }
  }, [isFlagSuccessful]);
  const handleFlagReview = e => {
    e.preventDefault();
    const flagReviewUrl = "".concat(mpacBaseUrl).concat(flagEndpoint);
    runFlagReview(flagReviewUrl, !isReviewFlagged);
  };
  const resetFlagBanner = () => setShowFlagBanner(null);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FlagGroup, {
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [showFlagBanner === 'failure' && /*#__PURE__*/_jsx(AutoDismissFlag, {
          id: "flag-feedback-not-submitted",
          icon: /*#__PURE__*/_jsx(CrossCircleIcon, {
            label: "Failure",
            color: "var(--ds-icon-danger, #C9372C)"
          }),
          title: "Feedback not submitted",
          description: "We\u2019re are unable to load your response. Refresh the page or try again in some time.",
          onDismissed: resetFlagBanner,
          actions: [{
            content: 'Got it',
            onClick: resetFlagBanner
          }]
        }, 1), showFlagBanner === 'success' && isReviewFlagged && /*#__PURE__*/_jsx(AutoDismissFlag, {
          id: "review-flagged",
          icon: /*#__PURE__*/_jsx(InformationIcon, {
            label: "Info",
            color: "var(--ds-icon-information, #1D7AFC)"
          }),
          title: "Review flagged",
          description: "We have received your request and will examine it shortly.",
          onDismissed: resetFlagBanner,
          actions: [{
            content: 'Got it',
            onClick: resetFlagBanner
          }]
        }, 0)]
      })
    }), isPopup ? /*#__PURE__*/_jsx(Popup, {
      isOpen: isOpen,
      onClose: () => setIsOpen(false),
      placement: "top",
      content: () => /*#__PURE__*/_jsx(DropdownItem, {
        onClick: handleFlagReview,
        children: /*#__PURE__*/_jsx(BodySmall, {
          children: isReviewFlagged ? 'Unflag' : 'Flag as inappropriate'
        })
      }),
      trigger: triggerProps => /*#__PURE__*/_jsx(IconButton, _objectSpread(_objectSpread({}, triggerProps), {}, {
        appearance: "subtle",
        icon: ShowMoreVerticalIcon,
        isSelected: isOpen,
        onClick: () => setIsOpen(prev => !prev),
        spacing: "compact",
        label: "More actions"
      }))
    }) : /*#__PURE__*/_jsx(FlagButton, {
      isLoading: isFlagInProgress,
      onClick: handleFlagReview,
      isFlagged: isReviewFlagged,
      appearance: "subtle-link",
      spacing: "none",
      iconBefore: /*#__PURE__*/_jsx(FlagIcon, {
        label: "",
        color: isReviewFlagged ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon-subtle, #626F86)"
      }),
      children: isReviewFlagged ? 'Unflag' : 'Flag as inappropriate'
    })]
  });
};